import React from "react";
import RequiredFieldsLabel from "../RequiredFieldsLabel/RequiredFieldsLabel";
import styles from "./dialog.module.scss";
const Legend = () => (React.createElement(RequiredFieldsLabel, { className: styles.legend }));
export default Legend;
//# sourceMappingURL=DialogLegend.js.map